import styled from 'styled-components';

export const ScalesContainer = styled.section`
  margin-top: 2rem;
`;

export const ItemsAmountRow = styled.div`
  padding-top: 30px;
  min-height: 47px;
`;
